import {binaryPostRequest} from "../../src/api/index.js";
import {USER_PROFILE_ERROR} from "../../src/actions/types.js";

// Uploads the raw image to the API, which validates, processes and stores it privately and saves it on the
// user. cb receives the new imageUrl (/user/profilepic/<userId>?v=...). No profile save is needed for the photo.
export const profileImageUpload = async (file, cb) => async (
    dispatch
) => {
    try {
        // Clear any previous error so the same message is shown again on a repeat failure.
        dispatch({
            type: USER_PROFILE_ERROR,
            payload: ''
        });

        const res = await binaryPostRequest(`/user/profilepic`, "user", file);

        await cb(res.data?.imageUrl ?? '');
    } catch (err) {
        if (err.response) {
            // 400 (not a supported image) and 413 (too large) carry a message for the user in errors[0]
            dispatch({
                type: USER_PROFILE_ERROR,
                payload: err.response.data?.errors?.[0] ?? err.message
            });
        } else if (err.request) {
            dispatch({
                type: USER_PROFILE_ERROR,
                payload: 'The image could not be uploaded. Please try again.'
            });
        } else {
            dispatch({
                type: USER_PROFILE_ERROR,
                payload: err?.message ?? "Something went wrong."
            });
        }
    }
};
